import { useCreateOrderMutation } from '../../api/api-hooks';
import { OrderForm } from './ordersTypes';

const useOrderItemCreator = () => {
  const [createOrder] = useCreateOrderMutation();
  return (item: OrderForm) => {
    if (
      item.company === null ||
      item.company === undefined ||
      !item.orderDate ||
      !item.price
    )
      return { error: { data: { message: 'Missing required fields' } } };
    return createOrder({
      // Create object to create, substituting null for empty strings
      createOrderDto: {
        companyId: item.company.id,
        purchaseOrderLink: item.purchaseOrderLink,
        purchaseOrderName: item.purchaseOrderName,
        quoteLink: item.quoteLink,
        quoteName: item.quoteName,
        orderDate: item.orderDate,
        price: item.price,
        notes: item.notes,
      },
    });
  };
};

export default useOrderItemCreator;
